import { useState } from "react";
import { Box, Container, Paper, Typography, Button, Alert, CircularProgress } from "@mui/material";
import { useCreateEcommercePublic } from "../../client/hooks/marketplace/marketplace.queries";
import { useCheckoutForm } from "./hooks/useCheckoutForm";
import SimpleEtiquetasCard from "./components/SimpleEtiquetasCard";
import CompanyForm from "./components/CompanyForm";
import UserForm from "./components/UserForm";
import SuccessScreen from "./components/SuccessScreen";

const FreemiumCheckout = () => {
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const { formData, errors, handleChange, validateForm } = useCheckoutForm();

  const { data, isLoading, error, refetch } = useCreateEcommercePublic(
    formData,
    { plan_type: "freemium", source: "landing" },
    submitAttempted
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setSubmitAttempted(true);
      refetch();
    }
  };


  if (data && !error) {
    return (
      <SuccessScreen
        title="Conta Criada com Sucesso!"
        message="Sua conta freemium foi criada. Verifique seu email para ativar a conta."
      />
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #2563eb 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        boxShadow: "inset 0 0 50px rgba(0, 0, 0, 0.3), inset 0 0 100px rgba(255, 255, 255, 0.1)",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ 
          display: "flex", 
          gap: { xs: 3, md: 6, lg: 8 }, 
          flexDirection: { xs: "column", lg: "row" },
          alignItems: { xs: "center", lg: "flex-start" },
          justifyContent: "center",
          minHeight: { xs: "auto", lg: "90vh" },
          py: { xs: 2, md: 4 }
        }}>
          <Box sx={{ 
            width: { xs: "100%", sm: "90%", md: "80%", lg: "42%" },
            maxWidth: { xs: "none", lg: "600px" },
            display: "flex",
            alignItems: "center"
          }}>
            <SimpleEtiquetasCard />
          </Box>

          <Box sx={{ 
            width: { xs: "100%", sm: "90%", md: "80%", lg: "42%" },
            maxWidth: { xs: "none", lg: "550px" },
            display: "flex",
            alignItems: "center"
          }}>
            <Paper elevation={10} sx={{ p: 4, borderRadius: 3, height: "fit-content" }}>
              <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center" sx={{ color: "#1f2937" }}>
                Teste Grátis o Sistema de Etiquetas
              </Typography>
              
              <Box sx={{ 
                textAlign: "center", 
                mb: 4, 
                p: 3, 
                backgroundColor: "#f0f9ff", 
                borderRadius: 3,
                border: "1px solid #3b82f6"
              }}>
                <Typography variant="h6" color="primary" fontWeight="bold" gutterBottom>
                  🏷️ Sistema de Etiquetas
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Gere etiquetas profissionais a partir das suas NF-es com formatação automática para impressão
                </Typography>
              </Box>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error?.response?.data?.msg || "Erro ao criar conta. Tente novamente."}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <CompanyForm formData={formData} errors={errors} handleChange={handleChange} />
                  <UserForm formData={formData} errors={errors} handleChange={handleChange} />
                  
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    size="large"
                    disabled={isLoading}
                    sx={{
                      mt: 2,
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                      },
                    }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Criar Conta Gratuita"
                    )}
                  </Button>
                </Box>
              </form>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FreemiumCheckout;